import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import RaceInfo from "../race/RaceInfo";
import EntriesTable from "../tables/EntriesTable";
import Pool from "../race/Pool";
import Results from "../race/Results";
import ChartTabs from "../chart/ChartTabs";
import ScoreUnscore from "../race/ScoreUnscore";
import ErrorCodes from "../../constants/ErrorCodes";
import { useSelectFunctions } from "../../functions";
import Rights from "../../constants/Rights";

const RaceTabs = ({
  entries,
  setEntries,
  RaceID,
  userInfo,
  raceInfo,
  setRaceInfo,
  stateTracks,
  setStateTracks,
  trackID,
  resultsList,
  setResultsList,
  getCharts,
  charts,
  selectOption,
  trackCode,
  racesTracks,
  setRefreshInfo,
  refreshInfo,
  setRefreshEntries,
  refreshEntries,
  activeChartTab,
  setActiveChartTab,
  sessionNoLongerExists,
  setSessionNoLongerExists,
  readOnlyResults,
  insertOrViewResults,
  setInsertOrViewResults,
  voidTickets,
  callTicketVoidListFrom,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
  scoreTickets,
  setCallTicketVoidListFrom,
  setSelectedTicketsVoidScoreContainer,
  selectedTicketsVoidScoreContainer,
  callPastPostMethod,
  setCallPastPostMethod,
}) => {
  const [activeBetTypes, setActiveBetTypes] = useState([]);
  const [activeTabs, setActiveTabs] = useState(false);
  const [pastPosts, setPastPosts] = useState([]);
  const [betTypeSelected, setBetTypeSelected] = useState(0);
  const [openTickets, setOpenTickets] = useState([]);
  const { getActiveBetTypes } = useSelectFunctions();
  const userRightsList = JSON.parse(localStorage.getItem("UserRights")) || [];

  let racesLength = racesTracks.length || 0;

  // This hook activates and deactivates the tabs when changing the race.
  useEffect(() => {
    if (selectOption.raceStatus === "C" || selectOption.raceStatus === "B") {
      document.getElementById("home-tab").classList.remove("active");
      document.getElementById("pool-tab").classList.remove("active");
      document.getElementById("chart-tab").classList.remove("active");
      document.getElementById("results-tab").classList.add("active");
      document.getElementById("scoreUnscore-tab").classList.remove("active");

      //Cuerpo del tab
      document.getElementById("pool").classList.remove("active", "show");
      document.getElementById("home").classList.remove("active", "show");
      document.getElementById("chart").classList.remove("active", "show");
      document.getElementById("results").classList.add("active", "show");
      document
        .getElementById("scoreUnscore")
        .classList.remove("active", "show");
    } else {
      //Tabs
      document.getElementById("home-tab").classList.add("active");
      document.getElementById("pool-tab").classList.remove("active");
      document.getElementById("chart-tab").classList.remove("active");
      document.getElementById("results-tab").classList.remove("active");
      document.getElementById("scoreUnscore-tab").classList.remove("active");
      //Cuerpo del tab
      document.getElementById("pool").classList.remove("active", "show");
      document.getElementById("home").classList.add("active", "show");
      document.getElementById("chart").classList.remove("active", "show");
      document.getElementById("results").classList.remove("active", "show");
      document
        .getElementById("scoreUnscore")
        .classList.remove("active", "show");
    }
    setActiveChartTab("Win");
    setBetTypeSelected(0);

    setPastPosts([]);
    setOpenTickets([]);
  }, [selectOption.raceID]);

  // This function executes the GetActiveBetTypes method that helps to assemble the active betTypes tabs for the chart.
  const betTypesActive = async () => {
    setSelectedTicketsVoidScore([]);
    setSelectedTicketsVoidScoreContainer([]);
    getCharts(betTypeSelected);
    setActiveBetTypes([]);
    setActiveTabs(false);
    const res = await getActiveBetTypes(
      {
        RaceID: RaceID,
      },
      userInfo.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setActiveBetTypes(res.Charts);
      setActiveTabs(true);
    }
  };

  const isDisabled = !userRightsList.find(
    (right) => right.FormName === Rights.FRM_CONSOLE,
  );

  return (
    <>
      <div className="col mt-1 mb-4">
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item">
            <a
              className={"nav-link"}
              id="home-tab"
              data-toggle="tab"
              href="#home"
              role="tab"
              aria-controls="home"
              aria-selected="true"
              onClick={() => {
                setRefreshInfo(!refreshInfo);
                setRefreshEntries(!refreshEntries);
              }}
            >
              Race Info{" "}
              <i
                className="fas fa-sync-alt ml-1"
                style={{ color: "#28a745", fontWeight: "bold" }}
              ></i>
            </a>
          </li>
          <li className="nav-item">
            <a
              className={"nav-link"}
              id="pool-tab"
              data-toggle="tab"
              href="#pool"
              role="tab"
              aria-controls="pool"
              aria-selected="false"
              onClick={() => {
                setRefreshEntries(!refreshEntries);
              }}
            >
              Pool{" "}
              <i
                className="fas fa-sync-alt ml-1"
                style={{ color: "#28a745", fontWeight: "bold" }}
              ></i>
            </a>
          </li>
          <li className="nav-item">
            <a
              className={"nav-link"}
              id="chart-tab"
              data-toggle="tab"
              href="#chart"
              role="tab"
              aria-controls="chart"
              aria-selected="false"
              onClick={() => {
                betTypesActive();
              }}
            >
              Chart{" "}
              <i
                className="fas fa-sync-alt ml-1"
                style={{ color: "#28a745", fontWeight: "bold" }}
              ></i>
            </a>
          </li>
          <li className="nav-item">
            <a
              className={"nav-link"}
              id="results-tab"
              data-toggle="tab"
              href="#results"
              role="tab"
              aria-controls="results"
              aria-selected="false"
            >
              Results
            </a>
          </li>
          <li className="nav-item">
            <a
              className={"nav-link"}
              id="scoreUnscore-tab"
              data-toggle="tab"
              href="#scoreUnscore"
              role="tab"
              aria-controls="scoreUnscore"
              aria-selected="false"
            >
              Score/Unscore
            </a>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <RaceInfo
              raceInfo={raceInfo}
              setRaceInfo={setRaceInfo}
              lengthRaces={racesLength}
              RaceID={RaceID}
              stateTracks={stateTracks}
              setStateTracks={setStateTracks}
              userInfo={userInfo}
              racesTracks={racesTracks}
              setSessionNoLongerExists={setSessionNoLongerExists}
              selectOption={selectOption}
              isDisabled={isDisabled}
            />
            <hr />
            <EntriesTable
              entries={entries}
              setEntries={setEntries}
              userInfo={userInfo}
              setSessionNoLongerExists={setSessionNoLongerExists}
              resultsList={resultsList}
              raceInfo={raceInfo}
              isDisabled={isDisabled}
            />
          </div>
          <div
            className="tab-pane fade"
            id="pool"
            role="tabpanel"
            aria-labelledby="pool-tab"
          >
            <Pool entries={entries} />
          </div>
          <div
            className="tab-pane fade"
            id="chart"
            role="tabpanel"
            aria-labelledby="chart-tab"
          >
            {activeTabs && (
              <ChartTabs
                entries={entries}
                getCharts={getCharts}
                charts={charts}
                activeBetTypes={activeBetTypes}
                raceID={RaceID}
                logonSessionID={userInfo.LogonSessionID}
                userInfo={userInfo}
                raceNumber={raceInfo.RaceNumber}
                setBetTypeSelected={setBetTypeSelected}
                betTypeSelected={betTypeSelected}
                activeChartTab={activeChartTab}
                setActiveChartTab={setActiveChartTab}
                sessionNoLongerExists={sessionNoLongerExists}
                setSessionNoLongerExists={setSessionNoLongerExists}
                voidTickets={voidTickets}
                callTicketVoidListFrom={callTicketVoidListFrom}
                selectedTicketsVoidScore={selectedTicketsVoidScore}
                setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
                selectAllTickets={selectAllTickets}
                setSelectAllTickets={setSelectAllTickets}
                scoreTickets={scoreTickets}
                setCallTicketVoidListFrom={setCallTicketVoidListFrom}
              />
            )}
          </div>
          <div
            className="tab-pane fade"
            id="results"
            role="tabpanel"
            aria-labelledby="results-tab"
          >
            {raceInfo && raceInfo.RaceStatus !== "O" ? (
              <Results
                raceInfo={raceInfo}
                setRaceInfo={setRaceInfo}
                raceSelected={RaceID}
                trackSelected={trackID}
                resultsList={resultsList}
                setResultsList={setResultsList}
                entries={entries}
                stateTracks={stateTracks}
                userInfo={userInfo}
                trackCode={trackCode}
                setSessionNoLongerExists={setSessionNoLongerExists}
                readOnlyResults={readOnlyResults}
                insertOrViewResults={insertOrViewResults}
                setInsertOrViewResults={setInsertOrViewResults}
                isDisabled={isDisabled}
              />
            ) : (
              <div
                style={{
                  textAlign: "center",
                  color: "rgb(128, 128, 128)",
                  fontWeight: "bold",
                }}
              >
                <div>
                  <span>
                    <img
                      src="../images/FlagBlack.png"
                      alt=""
                      className="mb-2 mr-2"
                    />
                  </span>
                </div>
                <label style={{ fontSize: "18px" }}>No results found</label>
              </div>
            )}
          </div>
          <div
            className="tab-pane fade"
            id="scoreUnscore"
            role="tabpanel"
            aria-labelledby="scoreUnscore-tab"
          >
            <ScoreUnscore
              raceSelected={RaceID}
              userInfo={userInfo}
              setRaceInfo={setRaceInfo}
              raceInfo={raceInfo}
              pastPosts={pastPosts}
              setPastPosts={setPastPosts}
              racesTracks={racesTracks}
              sessionNoLongerExists={sessionNoLongerExists}
              setSessionNoLongerExists={setSessionNoLongerExists}
              voidTickets={voidTickets}
              callTicketVoidListFrom={callTicketVoidListFrom}
              setSelectedTicketsVoidScoreContainer={
                setSelectedTicketsVoidScoreContainer
              }
              selectedTicketsVoidScoreContainer={
                selectedTicketsVoidScoreContainer
              }
              selectAllTickets={selectAllTickets}
              setSelectAllTickets={setSelectAllTickets}
              scoreTickets={scoreTickets}
              setCallTicketVoidListFrom={setCallTicketVoidListFrom}
              openTickets={openTickets}
              setOpenTickets={setOpenTickets}
              isDisabled={isDisabled}
              callPastPostMethod={callPastPostMethod}
              setCallPastPostMethod={setCallPastPostMethod}
              resultsList={resultsList}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default RaceTabs;
